import React, { useContext } from 'react'
import '../index.css'
// import { LinearProgress } from '@mui/material'
import { LoadingContext } from './loading.context'
import { useTranslation } from "react-i18next"

export function LoadingBar({ laneColor }) {
  const ctx = useContext(LoadingContext)
  const { t } = useTranslation()
  // const color = laneColor || ctx.primaryColor || "var(--color-black)"

  return (
    <div style={{ width: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', height: '80vh' }}>
      <div style={{ width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        {/* <LinearProgress style={{ height: '5px' }}
        sx={{
          backgroundColor: 'var(--color-grey-light)',
          '& .MuiLinearProgress-bar': {
            backgroundColor: color
          }
        }}
      /> */}
        <img src='/images/truckk.gif' style={{ width: 'auto', height: '350px', opacity: '50%' }} alt='LoadingImg' />
      </div>
      <div className="loader-container">
        <div className="loading-text" style={{ color: ctx.primaryColor || 'var(--color-black)' }}>{t("LabelLoading")}<span className="dots"></span></div>
      </div>
    </div>
  )
}